/**
 * The Update Schedule review body — Overdue and In-progress stacked as two
 * always-visible sections in one scroll (no hidden tabs: in-flight work is on
 * screen on the way through). Presentational: all state comes from
 * useOverdueReview; the host wraps this with its own chrome/actions.
 */
import React from "react";
import OverdueSection from "../OverdueSection/OverdueSection";
import InProgressSection from "../InProgressSection/InProgressSection";
import type { OverdueReviewState } from "../useOverdueReview";
import "./ReviewSections.css";

interface Props {
  r: OverdueReviewState;
}

const ReviewSections: React.FC<Props> = ({ r }) => {
  // In-progress is handled automatically — collapsed to one line unless the
  // user wants to adjust a remaining duration.
  const [inProgressOpen, setInProgressOpen] = React.useState(false);

  if (!r.loaded) {
    return r.error
      ? <div className="orv-msg orv-err">{r.error}</div>
      : <div className="orv-msg">Loading…</div>;
  }
  return (
    <div className="orv">
      {r.error && <div className="orv-msg orv-err">{r.error}</div>}
      <section className="orv-section">
        <OverdueSection
          data={r.review!}
          staged={r.staged}
          stagedPlans={r.stagedPlans}
          onStageActual={r.stageActual}
          onStagePlan={r.stagePlan}
          onUnstagePlan={r.unstagePlan}
          onUnstageSlot={r.unstageSlot}
          committing={r.committing}
        />
      </section>
      {r.autoCount > 0 && (
        <section className="orv-section">
          <button
            type="button"
            className="orv-collapse"
            aria-expanded={inProgressOpen}
            onClick={() => setInProgressOpen((o) => !o)}
          >
            <span className="orv-collapse-arrow">{inProgressOpen ? "▾" : "▸"}</span>
            In progress ({r.autoCount}) — remaining time recounts to the data
            date automatically.{inProgressOpen ? "" : " Open only to adjust."}
          </button>
          {inProgressOpen && (
            <InProgressSection
              data={r.auto!}
              edits={r.durationEdits}
              onEdit={r.editDuration}
            />
          )}
        </section>
      )}
    </div>
  );
};

export default ReviewSections;
